import { Button, TextField } from '@material-ui/core';
import { Search, Close, AutorenewRounded } from '@material-ui/icons';

import { useMenuHeader } from './hooks';

import { StoreSelector } from './components';

import makeClasses from './MenuHeader.style';

import type { Store, StoreId } from 'shared/domain';

const MAX_LENGTH_SEARCH_CHARACTERS = 30;

export function MenuHeader(props: Props) {
  const {
    searchQuery,
    store,
    stores,
    onSearch,
    onChangeStore,
    refreshCatalog,
  } = props;

  const showStoreSelector = stores.length > 1;

  const {
    lang,
    isLoadingCatalog,
    openStoreSelector,
    handleRefreshCatalog,
    handleOpenStoreSelector,
    handleCloseStoreSelector,
    handleClear,
    handleSearch,
  } = useMenuHeader({ onSearch, refreshCatalog });

  const _classes = makeClasses();

  return (
    <header className={_classes.header}>
      <section className={_classes.leftSide}>
        <div aria-label='page title'>
          <h1 className={_classes.title}>{lang.title}</h1>
          <p className={_classes.storeName}>{store.name}</p>
        </div>
        <AutorenewRounded
          onClick={handleRefreshCatalog}
          classes={{ root: isLoadingCatalog ? _classes.rotateCenter : '' }}
        />
      </section>

      <div className={_classes.rightSide}>
        <TextField
          fullWidth
          role='search'
          variant='outlined'
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            inputProps: { maxLength: MAX_LENGTH_SEARCH_CHARACTERS },
            endAdornment: searchQuery ? (
              <Close
                onClick={handleClear}
                className={_classes.searcherIcon}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <Search className={_classes.searcherIcon} />
            ),
          }}
          classes={{ root: _classes.searcher }}
          placeholder={lang.searcher.placeholder}
        />
        {showStoreSelector && (
          <Button
            variant='outlined'
            className={_classes.filterBtn}
            onClick={handleOpenStoreSelector}
          >
            {lang.filterBtn}
          </Button>
        )}
      </div>

      {showStoreSelector && (
        <StoreSelector
          store={store}
          stores={stores}
          open={openStoreSelector}
          changeStore={onChangeStore}
          onClose={handleCloseStoreSelector}
        />
      )}
    </header>
  );
}

interface Props {
  store: Store;
  stores: Store[];
  searchQuery: string;
  onSearch: (v: string) => void;
  onChangeStore: (id: StoreId) => void;
  refreshCatalog: () => void;
}
